import { copApi } from 'api'

export interface Company {
  id: string
  name: string
}
export const fetchCompanies = () => copApi.get<Company[]>('/companies/used')
